<template>
  <div>
    <b-card>
      <b-table
        responsive
        striped
        bordered
        hover
        :items="children"
        :fields="fields"
        show-empty
        empty-text="No child customers found"
      >
        <!-- SL -->
        <template #cell(sl)="data">
          {{ data.index + 1 }}
        </template>

        <!-- First Name -->
        <template #cell(first_name)="data">
          {{ data.item.first_name }}
        </template>

        <!-- Last Name -->
        <template #cell(last_name)="data">
          {{ data.item.last_name }}
        </template>

        <!-- Username -->
        <template #cell(username)="data">
          {{ data.item.username }}
        </template>

        <!-- Current Balance -->
        <template #cell(current_balance)="data">
          {{ data.item.current_balance }} tk
        </template>

        <!-- Action -->
        <template #cell(action)="data">
          <b-button size="sm" variant="success" @click="openTransferModal(data.item)">
            Transfer Now
          </b-button>
        </template>
      </b-table>
    </b-card>

    <!-- Transfer Modal -->
    <b-modal
      id="transfer-modal"
      title="Wallet Transfer"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-form @submit.prevent="submitTransfer">
        <div class="form-group">
          <label>Child Username</label>
          <input
            type="text"
            class="form-control"
            :value="selectedChild && selectedChild.username"
            readonly
          />
        </div>

        <div class="form-group">
          <label>Amount</label>
          <input
            type="number"
            class="form-control"
            v-model="transferAmount"
            placeholder="Enter amount"
            min="1"
          />
          <small class="text-danger" v-if="amountError">{{ amountError }}</small>
        </div>

        <div class="text-right mt-3">
          <b-button variant="secondary" class="mr-2" @click="$bvModal.hide('transfer-modal')">
            Cancel
          </b-button>

          <b-button variant="primary" @click="submitTransfer">
            Submit
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BTable, BButton, BModal, BForm } from "bootstrap-vue";
import api from "@/services/api";
import { decrypt } from "@/utils/crypto";

export default {
  components: {
    BCard,
    BTable,
    BButton,
    BModal,
    BForm,
  },

  data() {
    return {
      children: [],
      selectedChild: null,
      transferAmount: null,
      amountError: "",

      fields: [
        { key: "sl", label: "#" },
        { key: "first_name", label: "First Name" },
        { key: "last_name", label: "Last Name" },
        { key: "username", label: "Username" },
        { key: "current_balance", label: "Current Balance" },
        { key: "action", label: "Action" },
      ],
    };
  },

  methods: {
    async fetchChildren() {
      const userData = decrypt(localStorage.getItem("userData"));
      const username = userData?.username;

      const loader = this.$showCustomLoader();

      try {
        const res = await api.get(`/customer/child_customers/${username}/`);
        this.children = res.data || [];
      } catch (error) {
        console.error("Fetch failed:", error);

        this.$bvToast.toast("Failed to load child customers", {
          title: "Error",
          variant: "danger",
          solid: true,
        });
      } finally {
        loader?.hide();
      }
    },

    openTransferModal(child) {
      this.selectedChild = child;
      this.transferAmount = null;
      this.amountError = "";

      this.$bvModal.show("transfer-modal");
    },

    async submitTransfer() {
      if (!this.transferAmount || this.transferAmount < 1) {
        this.amountError = "Amount must be at least 1";
        return;
      }

      this.amountError = "";

      const loader = this.$showCustomLoader();

      try {
        const payload = {
          transfer_amount: this.transferAmount,
          child_id: this.selectedChild.id,
          child_username: this.selectedChild.username,
        };

        const res = await api.post("/customer/money_transfer_to_child/", payload);

        if (res.data?.status === true) {
          this.$bvToast.toast(res.data.message || "Transfer successful", {
            title: "Success",
            variant: "success",
            solid: true,
          });

          this.$bvModal.hide("transfer-modal");
          this.fetchChildren();

        } else {
          this.$bvToast.toast(res.data.message || "Transfer failed", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        }
      } catch (error) {
        console.error("Transfer error:", error);

        this.$bvToast.toast(
          error.response?.data?.message || "Transfer failed",
          {
            title: "Error",
            variant: "danger",
            solid: true,
          }
        );
      } finally {
        loader?.hide();
      }
    },
  },

  mounted() {
    this.fetchChildren();
  },
};
</script>